<template>
    <van-empty description="页面跑火星了，联系管理员"/>
</template>
<script>
    import {Empty} from 'vant';

    export default {
        components: {[Empty.name]: Empty},
        data() {
            return {}
        }
    }
</script>
<style scoped></style>
